import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './i18n'; // Minimal i18next setup (required by @selna/session-ui)
import './index.css';
import { initWebsiteAnalytics } from './utils/websiteAnalytics';

// Initialize website analytics (captures UTM params, checks for exclusion)
initWebsiteAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
